import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=3b4778a6&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"
import style0 from "./HeaderButtons.vue?vue&type=style&index=0&id=3b4778a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4778a6",
  null
  
)

export default component.exports